var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_100_",
    fill: "#FFFFFF",
    d: "M15.5,14.3v-2.4c0-2.6-1.2-3.7-2.5-3.7c-2.1,0-2.8,1.1-2.8,3.4V27c0,2.3,0.7,3.4,2.8,3.4 c1.9,0,2.5-1.1,2.5-3.1v-3.7h5.2v3.5c0,4.3-2.5,7.8-7.7,7.8c-5.5,0-8-3.5-8-7.8V11.5c0-4.3,2.5-7.8,8-7.8c5.2,0,7.7,3.8,7.7,8.3 v2.2H15.5z M63.2,34.5V4.2H68l6.3,17.4h0.1V4.2h4.7v30.4h-4.5l-6.6-19h-0.1v19H63.2z M83.9,34.5V4.2h4.8L95,21.5h0.1V4.2h4.7v30.4 h-4.5l-6.6-19h-0.1v19H83.9z M104.3,34.5V4.2h14v4.5h-8.7v7.8h6.7v4.5h-6.7V30h9.3v4.5H104.3z M131.9,14.3v-2.4 c0-2.6-1.2-3.7-2.5-3.7c-2.1,0-2.8,1.1-2.8,3.4V27c0,2.3,0.7,3.4,2.8,3.4c1.9,0,2.5-1.1,2.5-3.1v-3.7h5.2v3.5 c0,4.3-2.5,7.8-7.7,7.8c-5.5,0-8-3.5-8-7.8V11.5c0-4.3,2.5-7.8,8-7.8c5.2,0,7.7,3.8,7.7,8.3v2.2H131.9z M144.7,8.7h-5V4.2H155v4.5 h-5v25.8h-5.2V8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    fill: "#ff6b36",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M43.3,25.6 C43.3,25.6,43.3,25.6,43.3,25.6c-0.4,0.1-0.7,0.2-1.1,0.2c-0.3,0-0.6,0.1-0.9,0.1c-3.6,0-6.6-2.9-6.6-6.6c0-3.6,2.9-6.6,6.6-6.6 c0.3,0,0.6,0,0.9,0.1c0.4,0,0.7,0.1,1,0.2c0,0,0,0,0,0c2.6,0.8,4.6,3.3,4.6,6.2C47.9,22.3,46,24.8,43.3,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_94_",
    fill: "#ff6b36",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M41.3,3.8 c-8.6,0-15.6,7-15.6,15.6c0,2.6,0.7,5.1,1.8,7.3l11.9,23.9c0.5,1,1.2,1.5,1.8,1.5c0.7,0,1.3-0.5,1.8-1.5l11.9-23.9 c1.2-2.2,1.8-4.7,1.8-7.3C56.9,10.7,50,3.8,41.3,3.8z M41.3,28.4c-5,0-9-4.1-9-9c0-5,4.1-9,9-9c5,0,9,4.1,9,9 C50.4,24.3,46.3,28.4,41.3,28.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_29_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    fill: "#FFFFFF",
    d: "M68.6,39.7l4.1,18.8h-2l-1.1-5.6h-4.8l-1.1,5.6h-2l4.1-18.8H68.6z M65.1,51.2h4.2 l-2.1-10.1h-0.1L65.1,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    fill: "#FFFFFF",
    d: "M79.5,48.4c-0.3-1.2-0.8-2.1-2.3-2.1c-0.9,0-1.5,0.7-1.5,1.6c0,2.8,5.7,2.9,5.7,7.1 c0,2.1-1.6,3.7-3.7,3.7c-2.4,0-3.7-1.3-4.3-3.6l1.7-0.4c0.4,1.2,1.1,2.4,2.5,2.4c1,0,2-0.9,2-2.1c0-3.1-5.7-3.2-5.7-7.2 c0-1.8,1.5-3.3,3.5-3.3c2.1,0,3.3,1.2,3.8,3.2L79.5,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    fill: "#FFFFFF",
    d: "M89.2,48.4c-0.3-1.2-0.8-2.1-2.3-2.1c-0.9,0-1.5,0.7-1.5,1.6c0,2.8,5.7,2.9,5.7,7.1 c0,2.1-1.6,3.7-3.7,3.7c-2.4,0-3.7-1.3-4.3-3.6l1.7-0.4c0.4,1.2,1.1,2.4,2.5,2.4c1,0,2-0.9,2-2.1c0-3.1-5.7-3.2-5.7-7.2 c0-1.8,1.5-3.3,3.5-3.3c2.1,0,3.3,1.2,3.8,3.2L89.2,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    fill: "#FFFFFF",
    d: "M93.6,39.7h1.9v2.2h-1.9V39.7z M93.6,45h1.9v13.5h-1.9V45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    fill: "#FFFFFF",
    d: "M104,48.4c-0.3-1.2-0.8-2.1-2.3-2.1c-0.9,0-1.5,0.7-1.5,1.6c0,2.8,5.7,2.9,5.7,7.1 c0,2.1-1.6,3.7-3.7,3.7c-2.4,0-3.7-1.3-4.3-3.6l1.7-0.4c0.4,1.2,1.1,2.4,2.5,2.4c1,0,2-0.9,2-2.1c0-3.1-5.7-3.2-5.7-7.2 c0-1.8,1.5-3.3,3.5-3.3c2.1,0,3.3,1.2,3.8,3.2L104,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    fill: "#FFFFFF",
    d: "M106.7,45h1.8v-4.5h1.9V45h2.5v1.6h-2.5V56c0,0.8,0.4,1.4,1.4,1.4c0.4,0,0.8-0.2,1.1-0.3 v1.4c-0.5,0.2-1,0.3-1.8,0.3c-1.8,0-2.6-0.8-2.6-2.9v-9.3h-1.8V45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    fill: "#FFFFFF",
    d: "M114.8,48.7c0.4-2.1,1.6-4,4-4c2.5,0,3.9,1.5,3.9,3.9v7.5c0,1.2,0.1,2.1,0.3,2.4h-2 l-0.2-1.1c-0.7,0.7-2,1.4-2.9,1.4c-2.1,0-3.5-1.4-3.5-3.5c0-3.3,3.7-5,6.4-5.6v-1c0-1.5-0.8-2.4-2-2.4c-1.4,0-2.1,1.4-2.3,2.7 L114.8,48.7z M120.8,51.2c-1.7,0.5-4.5,1.8-4.5,3.9c0,1.3,0.6,2.1,1.9,2.1c1,0,1.9-0.7,2.6-1.4V51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    fill: "#FFFFFF",
    d: "M126.1,45h1.8v1.5c0.9-0.9,2.2-1.7,3.1-1.7c1.9,0,3,1,3,3.5v10.3H132v-10 c0-1.6-0.5-2.2-1.5-2.2c-0.9,0-1.7,0.6-2.6,1.7v10.6h-1.9V45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    fill: "#FFFFFF",
    d: "M142.5,49c-0.2-2-1-2.7-2.1-2.7c-1.6,0-2.3,1-2.3,5.5c0,4.5,0.7,5.5,2.3,5.5 c1.2,0,1.9-0.6,2.2-3h1.8c-0.3,2.7-1.6,4.5-4,4.5c-2.8,0-4.1-2.1-4.1-7c0-4.9,1.3-7,4.1-7c2.4,0,3.6,1.6,4,4.3H142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    fill: "#FFFFFF",
    d: "M147.7,52v0.8c0,3.3,0.8,4.4,2.5,4.4c1.4,0,2-1.3,2.3-2.6l1.8,0.2c-0.3,2-1.8,3.9-4.3,3.9 c-2.8,0-4.1-2.1-4.1-7c0-4.9,1.3-7,4.1-7c2.9,0,4.1,2.6,4.1,6.5V52H147.7z M152.2,50.5c-0.1-2.9-0.6-4.2-2.3-4.2 c-1.4,0-2.2,1-2.3,4.2H152.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogo);
export default __webpack_public_path__ + "static/media/ic_logo.7b98cfe65bcd42177c409875bca59cde.svg";
export { ForwardRef as ReactComponent };